var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5065 20 20 15.5065 20 10C20 4.49351 15.5064 0 10 0C4.49365 0 0 4.49365 0 10C0 15.5064 4.49365 20 10 20ZM10 1.2987C14.8052 1.2987 18.7013 5.19481 18.7013 10C18.7013 14.8052 14.8052 18.7013 10 18.7013C5.19481 18.7013 1.2987 14.8052 1.2987 10C1.2987 5.19481 5.19481 1.2987 10 1.2987Z",
    fill: "#05BC86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41561 13.5846C6.54552 13.7145 6.70133 13.7665 6.88305 13.7665C7.06496 13.7665 7.22077 13.7145 7.35049 13.5846L10.0001 10.9093L12.6754 13.5846C12.8053 13.7145 12.9611 13.7665 13.1428 13.7665C13.3247 13.7665 13.4806 13.7145 13.6103 13.5846C13.8701 13.3248 13.8701 12.9093 13.6103 12.6754L10.9093 10.0001L13.5846 7.32475C13.8444 7.06493 13.8444 6.64947 13.5846 6.41556C13.3248 6.15575 12.9093 6.15575 12.6754 6.41556L10.0001 9.09089L7.32475 6.41556C7.06493 6.15575 6.64947 6.15575 6.41556 6.41556C6.15575 6.67538 6.15575 7.09084 6.41556 7.32475L9.09089 10.0001L6.41556 12.6754C6.15593 12.9091 6.15593 13.3247 6.41556 13.5846H6.41561Z",
    fill: "#05BC86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelValue);
export default __webpack_public_path__ + "static/media/del-value.84e60ddabb7401f130bf7d06a71049d7.svg";
export { ForwardRef as ReactComponent };